import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorReportingService } from './error-reporting.service';

/**
 * Global Angular {@link ErrorHandler} that routes every uncaught error through
 * the reporting pipeline as a fatal incident. Diagnostics are redacted by the pipeline; logs remain generic.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  readonly #reporting = inject(ErrorReportingService);

  handleError(error: unknown): void {
    console.error('Unhandled application error');
    this.#reporting.report(error, 'fatal');
  }
}
